import { enumSubChartFlag } from "../constants";

export function PopulateBreakEntry(breakEntry, scNode) {
  var layout = scNode.GetLayout();
  var scFlag = layout.GetSubChartFlag();

  if (scFlag == enumSubChartFlag.drillup) breakEntry.fBottomSCNode = scNode;
  else breakEntry.fTopSCNode = scNode;
}
